function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M102.914 74.3156C103.653 75.0471 104.618 75.4167 105.584 75.4167C106.549 75.4167 107.514 75.0471 108.253 74.3081C109.724 72.8374 109.724 70.4467 108.253 68.9761L93.17 53.8928C91.6994 52.4221 89.3087 52.4221 87.8381 53.8928L72.7548 68.9761C71.2841 70.4467 71.2841 72.8374 72.7548 74.3081C74.2254 75.7787 76.6161 75.7787 78.0867 74.3081L86.7294 65.6654V147.062C86.7294 149.143 88.4187 150.833 90.5002 150.833C92.5817 150.833 94.271 149.143 94.271 147.062V65.6675L102.914 74.3156Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M136.851 104.482C137.59 105.213 138.556 105.583 139.521 105.583C140.486 105.583 141.452 105.213 142.191 104.474C143.661 103.004 143.661 100.613 142.191 99.1423L127.108 84.059C125.637 82.5884 123.246 82.5884 121.776 84.059L106.692 99.1423C105.222 100.613 105.222 103.004 106.692 104.474C108.163 105.945 110.554 105.945 112.024 104.474L120.667 95.8316V147.063C120.667 157.455 129.121 165.917 139.521 165.917H162.146C164.228 165.917 165.917 164.228 165.917 162.146C165.917 160.064 164.228 158.375 162.146 158.375H139.521C133.284 158.375 128.209 153.3 128.209 147.063V95.8338L136.851 104.482Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.9761 104.482C69.7152 105.213 70.6805 105.583 71.6458 105.583C72.6112 105.583 73.5765 105.213 74.3156 104.474C75.7862 103.004 75.7862 100.613 74.3156 99.1423L59.2323 84.059C57.7616 82.5884 55.3709 82.5884 53.9003 84.059L38.817 99.1423C37.3463 100.613 37.3463 103.004 38.817 104.474C40.2876 105.945 42.6783 105.945 44.1489 104.474L52.7915 95.8318V147.063C52.7915 153.299 47.7159 158.375 41.479 158.375H18.854C16.7725 158.375 15.0831 160.064 15.0831 162.146C15.0831 164.227 16.7725 165.917 18.854 165.917H41.479C51.8789 165.917 60.3331 157.455 60.3331 147.063V95.8336L68.9761 104.482Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M33.945 120C33.8018 120 33.666 119.992 33.5152 119.977C14.4121 117.866 0 101.816 0 82.655C0 62.8028 15.5283 46.5047 35.114 45.1747C40.3328 19.206 63.5989 0 90.5 0C111.624 0 131.082 11.8572 140.675 30.387C163.466 32.7689 181 52.0125 181 75.1409C181 95.2411 167.463 113.072 148.088 118.505C146.075 119.083 144.001 117.904 143.435 115.905C142.877 113.906 144.038 111.832 146.044 111.269C162.184 106.753 173.458 91.8898 173.458 75.1409C173.458 55.2511 157.9 38.8103 138.035 37.7132C136.64 37.6381 135.411 36.804 134.822 35.5492C126.843 18.5222 109.452 7.51409 90.5 7.51409C66.2535 7.51409 45.4235 25.5103 42.0448 49.3676C41.7808 51.216 40.1895 52.5986 38.3117 52.5986C21.0714 52.5986 7.54167 66.0789 7.54167 82.655C7.54167 97.9837 19.0653 110.818 34.3598 112.508C36.4263 112.741 37.9195 114.597 37.6857 116.656C37.4745 118.58 35.838 120 33.945 120Z",
  fill: "url(#paint0_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 90.5,
  y1: 0,
  x2: 90.5,
  y2: 120,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})));

function SvgIconUploading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 166,
    viewBox: "0 0 181 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploading);
export default __webpack_public_path__ + "static/media/icon-uploading.8614fedd.svg";
export { ForwardRef as ReactComponent };